import { useState, useEffect, type ReactNode } from 'react';
import { api } from '../api/client';
import { type AppConfig, ConfigContext } from './ConfigContext';

const defaultConfig: AppConfig = {
  features: {},
  printOrderingEnabled: false,
};

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<AppConfig>(defaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchConfig() {
      try {
        const data = await api.get<{ features?: Record<string, unknown>; printOrderingEnabled?: unknown }>(
          '/api/v1/config',
        );
        if (!cancelled) {
          const features: Record<string, boolean> = {};
          for (const [name, enabled] of Object.entries(data.features ?? {})) {
            features[name] = Boolean(enabled);
          }
          setConfig({
            features,
            printOrderingEnabled: Boolean(data.printOrderingEnabled),
          });
        }
      } catch {
        // On error, keep defaults (every feature disabled). Mirrors the backend
        // fail-safe: a control-plane failure hides features, never reveals them.
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchConfig();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}
